import { AnimatePresence, motion } from "framer-motion";
import React from "react";

import { pageVariants } from "../../animateConstant";
import useRouterType from "../../hook/useRouterType";

const PageAnimateWrapper = ({ children } = {}) => {
  const routerType = useRouterType();

  return (
    <motion.section
      variants={pageVariants}
      custom={routerType}
      initial="initial"
      animate="target"
      exit="exit"
      transition={{ type: "spring", duration: 0.55 }}
    >
      <AnimatePresence initial={false} mode="sync" custom={routerType}>
        {children}
      </AnimatePresence>
    </motion.section>
  );
};

export default PageAnimateWrapper;
